// Homepage Secondary Slider IDs
export const HOMEPAGE_BENEFITS_SLIDER = 1;
export const HOMEPAGE_BANNER_SLIDER = 2;
export const HOMEPAGE_CATEGORY_SLIDER = 3;
export const HOMEPAGE_INSURANCE_SLIDER = 4;
export const HOMEPAGE_MAGAZINE_SLIDER = 5;

// Homepage Secondary Slider Header Navigation Items
export const HOMEPAGE_NAV_ITEM_TAB = 1;
export const HOMEPAGE_NAV_ITEM_BUTTON = 2;
export const HOMEPAGE_NAV_ITEM_EXPEND_BUTTON = 3;

// Homepage Secondary Slider Tabs
export const HOMEPAGE_DEFAULT_SLIDER_TAB = -1;

// Homepage Secondary Space Check
export const SPACE_CHECK_TIMEOUT = 250;
